import z from "zod";
import { definePluginConfig } from "@/plugins/server/builder";
import type { MemoryDefinition } from "./builder";

export const memoriesPluginConfigDef = definePluginConfig({
  schema: z.object({
    items: z.array(z.custom<{ _definition: MemoryDefinition }>()).prefault([]),
  }),
  toTelemetry: (config) => {
    // Rewrite items to only keep their configs
    config.items = config.items.map((item) => ({
      config: item._definition.config,
    })) as never;
    return config;
  },
});
